export default "__VITE_ASSET__7SPaacaG__"